module.exports = __webpack_public_path__ + "static/media/spot1.8328c86d.webp";